export default __webpack_public_path__ + "static/media/user-default-image.a6143582.png";